import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { FAQConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DashboardTitle, InfoTooltip, useCompanyInvoiceMail } from "components/common";
import CopyButton from "components/common/buttons/copyButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const IncomingInvoiceReportTitle: React.FC = () => {
  const companyInvoiceMail = useCompanyInvoiceMail();
  const selectedCompanyId = useSelector((state: AppState) => state.auth.selectedCompanyId);
  const [revealCopyIcon, setRevealCopyIcon] = React.useState(false);

  // Reset the copy-icon reveal on company switch (the address itself is re-fetched by the hook).
  React.useEffect(() => {
    setRevealCopyIcon(false);
  }, [selectedCompanyId]);

  return (
    <Grid container direction="column">
      <DashboardTitle title={TranslationKeys.IncomingInvoice.IncomingInvoices} />
      {companyInvoiceMail && (
        <Grid
          container
          item
          direction="row"
          alignItems="center"
          columnGap={0.5}
          className={cssExports.formControlDescription}
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.CompanyInvoiceMailLabel)}
          <Grid
            item
            onMouseEnter={() => setRevealCopyIcon(true)}
            onMouseLeave={() => setRevealCopyIcon(false)}
            onFocus={() => setRevealCopyIcon(true)}
            onBlur={() => setRevealCopyIcon(false)}
          >
            <CopyButton copyText={companyInvoiceMail} showCopyIcon={revealCopyIcon}>
              {companyInvoiceMail}
            </CopyButton>
          </Grid>
          {/* SimpleTooltip is non-interactive, so the FAQ link is the icon itself rather than a link inside the tooltip. */}
          <a
            href={`${FAQConstants.FAQUrl}/${FAQConstants.FAQPageUrl}/${FAQConstants.SupplierInvoiceUrl}`}
            target="_blank"
            rel="noreferrer"
            className={cssExports.tooltipIconAlign}
          >
            <InfoTooltip
              text={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.IncomingInvoice.CompanyInvoiceMailTooltip
              )}
            />
          </a>
        </Grid>
      )}
    </Grid>
  );
};

export default IncomingInvoiceReportTitle;
